var FilePickerAction;
(function (FilePickerAction) {
    FilePickerAction[FilePickerAction["Attach"] = 0] = "Attach";
    FilePickerAction[FilePickerAction["Share"] = 1] = "Share";
    FilePickerAction[FilePickerAction["Insert"] = 2] = "Insert";
    FilePickerAction[FilePickerAction["AttachAndShare"] = 3] = "AttachAndShare";
})(FilePickerAction || (FilePickerAction = {}));
export default FilePickerAction;
//# sourceMappingURL=FilePickerAction.js.map